// @flow
import React from 'react'
import renderHTML from 'react-render-html'
import { Accordion, Icon } from 'semantic-ui-react'
import './styles.scss'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/accordion.css'

export default class Tab extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      isMobile: window.innerWidth < 650,
      isTablet: window.innerWidth < 800
    }
  }

  render() {
    let isActive = this.props.activeIndex.includes(this.props.index)
    return (
      <div className={isActive ? 'tab active' : 'tab'}>
        <Accordion.Title
          active={isActive}
          index={this.props.index}
          onClick={this.props.handleClick}
        >
          <div className='question'>{renderHTML(this.props.title)}</div>
          <div className='arrow'>
            <Icon name={isActive ? 'close small' : 'angle down'} />
          </div>
        </Accordion.Title>
        <Accordion.Content
          active={this.props.activeIndex.includes(this.props.index)}
        >
          {this.props.children}
        </Accordion.Content>
      </div>
    )
  }
}
